(() => {
  const SELECTOR = 'product-recommendations.related-products';

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  })[character]);

  const updateSection = (section) => {
    const list = section.querySelector('.product-grid-recommendations');
    if (!list) return;

    const vehicle = window.JsdVehicle?.get?.() || null;
    window.JsdVehicle?.updateFitmentBadges?.(vehicle, section);

    const items = [...list.querySelectorAll('.grid__item')];
    const existingNotice = section.querySelector('[data-related-vehicle-notice]');

    if (!vehicle) {
      items.forEach((item) => { item.hidden = false; });
      existingNotice?.remove();
      return;
    }

    const compatible = [];
    const incompatible = [];
    items.forEach((item) => {
      const fits = item.querySelector('[data-jsd-fitment-badge].is-fit');
      (fits ? compatible : incompatible).push(item);
    });

    if (compatible.length) {
      compatible.forEach((item) => { item.hidden = false; });
      incompatible.forEach((item) => { item.hidden = true; });
      existingNotice?.remove();
      return;
    }

    items.forEach((item) => { item.hidden = true; });
    const collectionUrl = vehicle.collection
      ? `${window.Shopify?.routes?.root || '/'}collections/${encodeURIComponent(vehicle.collection)}`
      : '/collections/all';
    const label = vehicle.label || [vehicle.title, vehicle.year].filter(Boolean).join(' ') || 'your vehicle';
    const notice = existingNotice || document.createElement('div');
    notice.className = 'related-products__vehicle-notice';
    notice.dataset.relatedVehicleNotice = 'true';
    notice.innerHTML = `<p>No related products in this set fit <strong>${escapeHtml(label)}</strong>.</p><a class="button button--primary" href="${escapeHtml(collectionUrl)}"><span>View Compatible Parts</span></a>`;
    if (!existingNotice) list.before(notice);
  };

  const initialize = (section) => {
    if (section.dataset.fitmentRecommendationsReady === 'true') return;
    section.dataset.fitmentRecommendationsReady = 'true';
    let frame;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => updateSection(section));
    };
    new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
    document.addEventListener('jsd:vehicle-change', schedule);
    schedule();
  };

  const initializeAll = (root = document) => {
    if (root instanceof Element && root.matches(SELECTOR)) initialize(root);
    root.querySelectorAll?.(SELECTOR).forEach(initialize);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
